<template>
    <v-container  class="evaluate">
        <div class="mt-5 text-xs-center" v-if="question_list.length==0&&!is_error">Loading....please wait</div>
        <error-landing  v-else-if="is_error" :msg="error_msg"/>
        <div v-else>
            <div class="text-xs-center mt-5">
                <h1>ประเมิน{{ selected_service.serviceD_name }}</h1>
            </div>
            <div class="empSearch">
                <v-card>
                    <v-snackbar
                            v-model="snackbar.show"
                            color="red"
                            :timeout="6000"
                            top
                            multi-line
                    >
                        <div class="white--text"><v-icon light class="white--text">mdi-alert</v-icon>&nbsp;&nbsp;{{ snackbar.msg }}</div>
                        <v-btn
                            dark
                            flat
                            @click="snackbar.show = false"
                        >
                            Close
                        </v-btn>
                    </v-snackbar>
                </v-card>

                <loading-scr :value="loading_state" :message="'กำลังโหลดข้อมูล...กรุณารอสักครู่ค่ะ'" :progressColor="'blue'" />
                <!-- หน้าบันทึกสำเร็จ -->
                <eva-thankyou  v-if="current_state=='thankyou'" :back_btn="false" />
                <!-- หน้ารายการประเมิน -->
                <div v-else>
                    <div class="text-xs-center mt-4 blue--text"><h2>
                        <!--<v-icon class="blue&#45;&#45;text">mdi-star</v-icon>-->
                        ประเมินฝ่าย {{ selected_service.dept_code }}</h2>
                        <p class="black--text"><span class="font-weight-bold">ผู้ถูกประเมิน : </span>{{ data_staff.FULL_NAME }} ({{ data_staff.EORG_04 }})</p>

                    </div>
                    <v-flex xs12 sm8 md6 offset-md3 offset-sm2>
                        <v-layout row wrap class="mt-3">
                            <v-card v-for="(question,index) in question_list.result" class=" mb-3 pa-2 pt-3 pb-3 each_question">
                                <div class="text-xs-left">
                                    <!--{{ index+1 }}-->
                                    {{ question.question_desc }}
                                </div>
                                <rating-star :question_id="question.question_id"  @set_score="setScore"/>
                            </v-card>
                        </v-layout>
                    </v-flex>
                    <div class="text-xs-center mt-3">
                        <p><span class="font-weight-bold">ผู้ประเมิน : </span>{{ selected_emp.FULL_NAME }} ({{ selected_emp.EORG_04 }})</p>
                        <v-flex xs6 sm2 md2 offset-md5 offset-sm5 offset-xs3>
                            <v-btn color="success" large block class="font-weight-bold mt-3" @click="saveScore()" :disabled="save_btn_disabled">บันทึก</v-btn>
                        </v-flex>
                    </div>
                </div>

            </div>
        </div>
    </v-container>
</template>

<script>
    import EventBus from '@/EventBus'
    import axios from '@/axios'
    import RatingStar from '@/components/RatingStar'
    import EvaThankyou from '@/components/after_evaluate/EvaThankyou'
    import LoadingScr from '@/components/Loading'
    import ErrorLanding from '@/components/ErrorLanding'

    export default {
        name: "Eval",
        components: {
            ratingStar:RatingStar,
            evaThankyou:EvaThankyou,
            loadingScr:LoadingScr,
            errorLanding:ErrorLanding,
        },
        data(){
            return{
                loading_state:false,
                code:this.$route.query.code,
                data_ref:{
                    username:'',
                    em_code:'',
                    service_id:'',
                    create_date:'',
                    dept_id:''
                },
                selected_service:{},
                selected_emp:{},
                question_list:[],
                data_staff:{},
                question_origin:[],
                eva_score:[],
                question_id:[],
                snackbar:{
                    show:false,
                    msg:"Alert"
                },
                current_state:'evaluate',
                is_error:false,
                error_msg:'',
                save_btn_disabled:true,
                status_type: null,
                //line_token:'fEFse0aoM9oI09jotrtllz6W1okMt2E61tmP1HDcgAW'
                line_token:'Dnsv7q6iaTr0Nv6HgYWPh1ZrUiXcmNkJnSUec9ktd2P'
            }
        },
        async created() {
            //this.loading_state = true
            await this.getDataRef()
            if (!this.data_ref.em_code) { // การประเมินแบบ multi ต้องไปหา emcode จาก user login
                this.status_type = 'multi'
                const uri = '/getEmCode'
                const res = await axios.post(uri, {
                    username: /*'saparamee'*/ this.getLocalItem() && this.getLocalItem().user_id
                })
                if(res.data.status=='ok') {
                    this.data_ref.em_code = JSON.parse(JSON.stringify(res.data.result[0]).toLowerCase()).em_code
                }
            }
            if (this.data_ref.em_code) {
                await this.getService()
                await this.getDataStaff('EM_CODE',this.data_ref.em_code)
                await this.getDataStaff('USERNAME',this.data_ref.username)
                //this.loading_state = true
                await this.getQuestion()
            } 

        },
        methods:{
            async getDataRef()
            {
                try{
                    const uri = '/getDataByURI'
                    const res = await axios.post(uri, {
                        uri_code:this.code
                    })

                    if(res.data.status=='ok') {

                            console.log('here',res.data.result.em_code)
                            this.data_ref = res.data.result
                        console.log(this.data_ref)
                    }else if(res.data.status=='done'){
                        this.is_error = true
                        this.error_msg = res.data.msg
                    }else{
                        this.is_error = true
                        this.error_msg = res.data.msg
                        this.data_ref = {
                            username:'',
                            em_code:'',
                            service_id:'',
                            create_date:'',
                            dept_id:''
                        }
                    }
                }catch(err)
                {
                    this.data_ref = {
                        username:'',
                        em_code:'',
                        service_id:'',
                        create_date:'',
                        dept_id:''
                    }
                    console.log(err.message)
                }
            },
            async getService()
            {
                try{
                    const uri = '/getDeptService'
                    const res = await axios.post(uri, {
                        qfield:'serviceD_id',
                        qval:this.data_ref.service_id,
                        qfield2:'dept_id',
                        qval2:this.data_ref.dept_id
                    })
                    if(res.data.result.length>0) {
                        this.selected_service = res.data.result[0]
                    }else{
                        const res2 = await axios.post(uri, {
                            qfield:'serviceD_id',
                            qval:this.data_ref.service_id
                        })
                        if(res2.data.result.length>0) {
                            this.selected_service = res2.data.result[0]
                        }else{
                            this.selected_service = {}
                        }
                    }
                }catch(err)
                {
                    this.selected_service = {}
                    console.log(err.message)
                }
            },
            async getDataStaff(field,qval)
            {
                try{
                    const uri = '/getDataStaffPublic'
                    const res = await axios.post(uri, {
                        query_value:qval,
                        field_type:field,
                        uri_code:this.code
                    })
                    console.log('getDataStaffPublic', field,res.data.result)
                    if(res.data.status=='ok') {
                        if(field=='EM_CODE'){
                            this.selected_emp = res.data.result
                        }else if(field=='USERNAME'){
                            this.data_staff = res.data.result
                        }
                        
                    }else{
                        if(field=='EM_CODE'){
                            this.selected_emp = {}
                        }else if(field=='USERNAME'){
                            this.data_staff = {}
                        }
                    }
                }catch(err)
                {
                    if(field=='EM_CODE'){
                        this.selected_emp = {}
                    }else if(field=='USERNAME'){
                        this.data_staff = {}
                    }
                    console.log(err.message)
                }
            },
            async getQuestion()
            {
                try{
                    const uri = '/GetQuestion'
                    const res = await axios.post(uri, {
                        service_id:this.data_ref.service_id
                    })
                    this.question_list = res.data
                    this.question_origin = res.data.result.map(rows=>(
                        rows.question_id
                    ))
                }catch(err)
                {
                    this.question_list = []
                    console.log(err.message)
                }
            },
            setScore(qs){

                if(!this.question_id.includes(qs.question_id)) {
                    this.question_id.push(qs.question_id)
                    this.eva_score.push(qs.score)
                }else{
                    let idx = this.question_id.findIndex(k => k===qs.question_id)
                    this.eva_score[idx] = qs.score
                }

                if(this.question_origin.length!=this.question_id.length) {
                    this.save_btn_disabled = true
                }else{
                    this.save_btn_disabled = false
                }

            },
            async saveScore(){
                console.log('this.data_staff', this.data_staff)
                if (this.status_type === 'multi') { // ประเมินหลายคน
                     try {
                        let obj = {
                            username: this.data_staff.EM_MAIL.split('@lpn.co.th').join(''),
                            em_code: this.data_ref.em_code,
                            service_id: this.data_ref.service_id,
                            question_id: this.question_id,
                            point: this.eva_score,
                            service_dept_id: this.selected_service.dept_id,
                            service_dept_code: this.selected_service.dept_code
                        }
                        const uri = '/saveEvaluate'
                        // console.log('obj', obj)
                        // return
                        const res = await axios.post(uri, obj)

                        if(res.data.status=='ok'){
                            this.current_state = 'thankyou'

                            if(this.selected_service.dept_code=='MIS'&&this.eva_score<10) {
                                let do_service_date =  this.$moment(new Date()).format("DD/MM/YYYY เวลา HH:mm น.")
                                let msg = ""
                                msg += "แจ้งเตือนมีผู้ถูกประเมินฝ่าย MIS ได้คะแนนต่ำกว่า 10"
                                msg += "\nผู้ถูกประเมิน : " + this.data_staff.FULL_NAME + " (" + this.data_staff.EM_NICKNAME + ")"
                                //msg += "\nผู้ประเมิน : " + this.selected_emp.FULL_NAME_SERACH + " (" + this.selected_emp.EM_NICKNAME + " " + this.selected_emp.EORG_04 + ")"
                                msg += "\nคะแนนที่ได้ : " + this.eva_score
                                msg += "\nเรื่องที่ประเมิน : " + this.selected_service.serviceD_name
                                msg += "\nวันที่ให้บริการ : " + do_service_date
                                // this.sendLineNotify(msg)
                            }

                        }else{
                            this.current_state = 'evaluate'
                        }

                    } catch (err) {
                        console.log(err.message)
                    }
                } else {
                    // return
                    if(this.question_origin.length!=this.question_id.length){
                        this.snackbar.show = true
                        this.snackbar.msg = "กรุณาทำประเมินให้ครบทุกข้อค่ะ!!"
                        return false
                    }else {
                        this.save_btn_disabled = true

                        try {
                            const uri = '/saveEvaluatePublic'
                            const res = await axios.post(uri, {
                                uri_code:this.code,
                                username: this.data_ref.username,
                                em_code: this.data_ref.em_code,
                                service_id: this.data_ref.service_id,
                                question_id: this.question_id,
                                point: this.eva_score,
                                service_dept_id: this.selected_service.dept_id,
                                service_dept_code: this.selected_service.dept_code
                            })

                            if(res.data.status=='ok'){
                                this.current_state = 'thankyou'

                                if(this.selected_service.dept_code=='MIS'&&this.eva_score<10) {
                                    let do_service_date =  this.$moment(this.data_ref.create_date=='' ? new Date():this.data_ref.create_date).format("DD/MM/YYYY เวลา HH:mm น.")
                                    let msg = ""
                                    msg += "แจ้งเตือนมีผู้ถูกประเมินฝ่าย MIS ได้คะแนนต่ำกว่า 10"
                                    msg += "\nผู้ถูกประเมิน : " + this.data_staff.FULL_NAME + " (" + this.data_staff.EM_NICKNAME + ")"
                                    //msg += "\nผู้ประเมิน : " + this.selected_emp.FULL_NAME_SERACH + " (" + this.selected_emp.EM_NICKNAME + " " + this.selected_emp.EORG_04 + ")"
                                    msg += "\nคะแนนที่ได้ : " + this.eva_score
                                    msg += "\nเรื่องที่ประเมิน : " + this.selected_service.serviceD_name
                                    msg += "\nวันที่ให้บริการ : " + do_service_date
                                    this.sendLineNotify(msg)
                                }

                            }else{
                                this.current_state = 'evaluate'
                            }

                        } catch (err) {
                            console.log(err.message)
                        }
                        this.save_btn_disabled = false

                    }
                }
            },
            async sendLineNotify(msg){
                try {

                    const res = axios.post('https://us-central1-line-api-6e025.cloudfunctions.net/lineNotify', null, { params: {
                            token:this.line_token,
                            message: msg
                        }})
                    if (res){
                        console.log(res)
                    }

                } catch (err) {
                    console.log(err.message)
                }

            }
        }
    }
</script>

<style scoped>
    .each_question{
        border-radius: 10px;
        width: 100%;
    }
</style>